<template>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.875 12C14.3359 12 16.375 9.99609 16.375 7.5C16.375 5.03906 14.3359 3 11.875 3C9.37891 3 7.375 5.03906 7.375 7.5C7.375 9.99609 9.37891 12 11.875 12ZM15.0039 13.125H14.4062C13.6328 13.5117 12.7891 13.6875 11.875 13.6875C10.9609 13.6875 10.082 13.5117 9.30859 13.125H8.71094C6.10938 13.125 4 15.2695 4 17.8711V19.3125C4 20.2617 4.73828 21 5.6875 21H18.0625C18.9766 21 19.75 20.2617 19.75 19.3125V17.8711C19.75 15.2695 17.6055 13.125 15.0039 13.125Z"
        />
    </svg>
</template>
